import { Decimal } from 'decimal.js';

/**
 * A Price table representation of 'plan_id' -> 'price' in decimal string.
 * @typedef {Object.<string, Decimal>} PriceTable
 */

/**
 * The price table version.
 * @typedef {string} PriceVersion Either '0' or '1'.
 */

/**
 * The pricing table representation. This follows the format: {
 *  Version ('0' or '1'): {
 *   'plan_id': 'price (e.g. "0.00" or "89.00")'
 *  }
 * }
 * @typedef {Object.<PriceVersion, PriceTable>} PriceTableVersion
 */

/**
 * A representation of a Plan with the Price attached from the Pricing Table.
 * @typedef {Object} PlanChoice
 * @property {string} planId Plan ID
 * @property {string} plan The plan's featureGroup
 * @property {string} price The plan's price as a decimal string
 * @property {number} pageviews The sample rate/pageviews
 */

angular.module('hjApp').service('PriceV2', [
    'Plan',
    'Pricing',
    function (Plan, Pricing) {
        /**
         * Get the list of Plan Choices.
         *
         * @param {Object} account The account.
         * @returns {PlanChoice[]} The list of plan choices.
         * @deprecated This should not be used - prefer Pricing.byAccount() instead.
         */
        this.getPlanIdChoices = function getPlanIdChoices(account) {
            var pricingTable = Pricing.byAccount(account);
            return _.map(pricingTable, function (price, planId) {
                var plan = Plan.byId(planId);
                return {
                    planId: plan.identifier,
                    plan: plan.featureGroup,
                    price: price.toString(),
                    pageviews: plan.sampleRate
                };
            });
        };
    }
]);

angular.module('hjApp.revenue').service('Pricing', function ($window) {
    var self = this,
        pricingTables = _.mapValues($window.settings.pricing_tables, _.partial(_.mapValues, _, Decimal));

    /**
     * Returns the pricing table for a given version
     *
     * @param {PriceVersion} version The version of the pricing table
     * @returns {PriceTable|undefined} The price table for the given version (or undefined).
     */
    this.byVersion = function byVersion(version) {
        return _.cloneDeep(pricingTables[version], function (value) {
            if (value instanceof Decimal) {
                // We can't just clone a decimal, we must copy it via
                // creating a new one with the given value
                return new Decimal(value);
            }
            return undefined; // Fallback to _.cloneDeep() default behaviour.
        });
    };

    /**
     * Returns the pricing table for a given account based on its pricing
     * table version.
     *
     * @param {Account} account The account to lookup the price table for.
     * @returns {PriceTable} The price table versioned to the given account.
     */
    this.byAccount = function byAccount(account) {
        if (account && !_.isUndefined(account.pricing_table_id)) {
            return self.byVersion(account.pricing_table_id);
        }
        return self.byVersion('0');
    };
});
